// src/Routes/PrivateRouteInfluenceur.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthInfluenceur } from '../Redux/authInfluenceurSlice';

const PrivateRouteInfluenceur = ({ children, redirectPath = "/influenceur/login" }) => {
    const isAuthenticated = useSelector(
        (state) => selectAuthInfluenceur(state).isAuthenticated
    );

    return isAuthenticated ? children : <Navigate to={redirectPath} replace />;
};

export default PrivateRouteInfluenceur;
